import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { GetUserId } from '@core/utils';
import { Pagination } from '@core/entities';
import { map } from 'rxjs/operators';
import { FilterQuery } from '@core/types';

@Injectable({
  providedIn: 'root',
})
export class InstructorService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;
  private readonly _userId = GetUserId();

  find(pagination: Pagination, queryParams?: FilterQuery) {
    return this._http.get<any>(`${this._apiUrl}/getInstructor?page=${pagination.page}&pageSize=${pagination.pageSize}`, { params: queryParams }).pipe(map((res: any) => res.result));
  }

  get(id: number) {
    return this._http.get<any>(`${this._apiUrl}/getInstructorById/${id}`).pipe(map((res: any) => res.result));
  }

  create(formData: any) {
    return this._http.post<any>(`${this._apiUrl}/createInstructor`, formData);
  }

  update(id: number, formData: any) {
    return this._http.put<any>(`${this._apiUrl}/updateInstructor/${id}`, formData);
  }

  delete(id: number) {
    return this._http.delete<any>(`${this._apiUrl}/deleteInstructor/${id}`);
  }

  getAllInternalInstructors() {
    return this._http.get<any>(`${this._apiUrl}/getInternalInstructor`).pipe(map((res: any) => res.result));
  }
}
